import { useAtomValue } from 'jotai';
import { useTranslation } from '@wojtekmaj/react-t';
import Markdown from 'markdown-to-jsx';

import {
  Body,
  HeaderContentWrapper,
  HeaderWrapper,
  MessageDate,
  Picture,
  Subject,
} from './message_content.styles';

import MessagePoll from './message_poll';

import { formatRelative } from '../../../../../utils/date';

import { vendorMessageQuery } from '../../../../../store';

import type { Message } from '@rewardopl/types';

type MessageContentProps = {
  buttonClassName?: string;
  messageId: Message['_id'];
};

export default function MessageContent({ buttonClassName, messageId }: MessageContentProps) {
  const message = useAtomValue(vendorMessageQuery(messageId));

  const pictureString = useTranslation('Picture');

  return (
    <>
      <HeaderWrapper>
        <HeaderContentWrapper>
          <Subject>{message.subject}</Subject>
          <MessageDate>{formatRelative(message.created_at)}</MessageDate>
        </HeaderContentWrapper>
      </HeaderWrapper>
      {message.attachment ? (
        <Picture alt={pictureString} src={`/api/uploads/${message.attachment}`} />
      ) : null}
      <Body>
        <Markdown>{message.body}</Markdown>
      </Body>
      <MessagePoll buttonClassName={buttonClassName} messageId={messageId} />
    </>
  );
}
